import type { StepType } from "@reactour/tour";

export const tourSteps: StepType[] = [
	{
		selector: "[data-tour-id='title']",
		content:
			"Esta es la pantalla de configuración de referencias para tu empresa. Aquí debes dar de alta todas las cosas que tengan un impacto en la huella de carbono de tu empresa, así como que factor de emisión tienen.",
	},
	{
		selector: "[data-tour-id='add-concept-button']",
		content: "Pulsa este botón para añadir un nuevo concepto a la tabla.",
	},
	{
		selector: '[data-tour-id="header-factor"]',
		content:
			"El factor de emisión es el valor que se utiliza para calcular la huella de carbono de cada referencia.",
	},
	{
		selector: '[data-tour-id="header-referencia"]',
		content:
			"La referencia es el nombre del concepto que se está configurando. Puedes usar una referencia genérica como 'Electricidad', pero también puedes ser más especifico, y separar por ejemplo 'Electricidad: Pabellón 1' de 'Electricidad: Oficina'.",
	},
	{
		selector: '[data-tour-id="header-unidad"]',
		content:
			"La unidad es la medida en la que se mide el consumo de la referencia. Por ejemplo, 'kWh' para electricidad, 'litros' para combustible, etc.",
	},
	{
		selector: '[data-tour-id="header-co2"]',
		content:
			"El CO2 equivalente es el valor equivalente de una unidad del factor. Por ejemplo, para el factor Gasolina de un Turismo, el CO2 equivalente es 2.6 kg de CO2 por litro de gasolina. Este valor se actualiza anualmente según los valores de la calculadora MITECO.",
	},
	{
		selector: '[data-tour-id="header-acciones"]',
		content:
			"La última columna permite eliminar una referencia, para que no se siga mostrando a la hora de hacer imputaciones.",
	},
	{
		selector: '[data-tour-id="submit-button"]',
		content:
			"El botón de guardar salva los cambios realizados en la configuración.",
	},
];
